module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/accountmaster/pigmy-creation-grid/pigmy-creation-grid.component.css
// module id = ./src/app/accountmaster/pigmy-creation-grid/pigmy-creation-grid.component.css
// module chunks = main